import { render, staticRenderFns } from "./selectorPC.vue?vue&type=template&id=38de9fad&scoped=true"
import script from "./selectorPC.vue?vue&type=script&lang=js"
export * from "./selectorPC.vue?vue&type=script&lang=js"
import style0 from "./selectorPC.vue?vue&type=style&index=0&id=38de9fad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38de9fad",
  null
  
)

export default component.exports